<mat-expansion-panel [expanded]="expanded" (toggle)="toggleCollapse($event)">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <span class="titleN2">{{ title }}</span>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <ng-content></ng-content>

</mat-expansion-panel>